import { Blocks } from "blocks/Blocks";
import { SkipToContent } from "src/ts/site/SkipToContent";
import { Header } from "templates/header/Header";
import { AnchorLink } from "src/ts/site/modules/AnchorLink";
import { LazyLoadRevealHandler } from "src/ts/site/LazyLoadRevealHandler";
import { gsap } from "node_modules/gsap/gsap-core";
import SplitText from "node_modules/gsap/gsap-core";
import ScrollToPlugin from "node_modules/gsap/gsap-core";
import { RevealHandler } from "src/ts/site/RevealHandler";
import { CopyToClipboard } from "src/ts/site/CopyToClipboard";
import { Footer } from "templates/footer/Footer";
import { Parallax } from "src/ts/site/modules/Parallax";
import { RedDot } from "./modules/RedDot";
import { Error404 } from "templates/error404/Error404";
//import { Batman } from "src/ts/site/Batman";
gsap.registerPlugin(SplitText);
gsap.registerPlugin(ScrollToPlugin);
export class Site {
    constructor() {
        this.SCROLL_AMOUNT_MIN = 50;
        this.SELECTOR_CONTENT = "#content";
        this.SKIP_TO_CONTENT_LINKTEXT = "Skip to main content";
        this.ghSrc = null;
        //l('site init');
        const doc = document.documentElement;
        doc.style.setProperty("--app-height", window.innerHeight + "px");
        if (this.iOS()) {
            document.body.classList.add("ios");
        }
        else {
            this.redDot = new RedDot();
        }
        //const batman: Batman = new Batman();
        this.blocks = new Blocks(this.redDot);
        const isBlockEditorContext = this.isBlockEditorContext();
        if (isBlockEditorContext) {
            //l("Blocks initialized. Not initializing header or other end user facing features, such as lazy loading or image reveal, as we are in block editor.");
            return;
        }
        if (document.querySelector("header.header")) {
            this.header = new Header();
        }
        //skipt to content uses AnchorLink to scroll
        this.skipToContent = new SkipToContent(this.SELECTOR_CONTENT, this.SKIP_TO_CONTENT_LINKTEXT);
        this.lazyLoadRevealHandler = new LazyLoadRevealHandler();
        this.revealHandler = new RevealHandler();
        this.footer = new Footer();
        document.querySelectorAll('[jss="copy-to-clipboard"]').forEach((element) => {
            new CopyToClipboard(element);
        });
        document.querySelectorAll('[jss="parallax"]').forEach((element) => {
            new Parallax(element);
        });
        document.querySelectorAll('a[href*="#"]').forEach((element) => {
            if (!element.classList.contains("no-scroll")) {
                new AnchorLink(element);
            }
        });
        const hash = window.location.hash;
        // to top right away
        if (hash) {
            scroll(0, 0);
            // void some browsers issue
            setTimeout(function () {
                scroll(0, 0);
            }, 1);
        }
        if (hash.length > 2) {
            const hashElement = document.querySelector(hash);
            if (hashElement) {
                gsap.to(window, { duration: 0.7, scrollTo: { y: hash, offsetY: 32 } });
            }
            else {
                setTimeout(() => {
                    window.scrollTo(window.scrollX, window.scrollY - 1);
                    window.scrollTo(window.scrollX, window.scrollY + 1);
                }, 100);
            }
        }
        else {
            setTimeout(() => {
                window.scrollTo(window.scrollX, window.scrollY - 1);
                window.scrollTo(window.scrollX, window.scrollY + 1);
            }, 100);
        }
        if (document.body.classList.contains("error404")) {
            const errorSection = document.querySelector("section.error404");
            if (errorSection) {
                new Error404(errorSection, this.header.getSearch());
            }
        }
        //let iOS = ['iPad', 'iPhone', 'iPod'].indexOf(navigator.platform) >= 0;
        /* main animation */
        //if mobile
        if (window.innerWidth < 1024) {
            document.querySelector("main").classList.remove("page-anim");
            document.querySelector("main").classList.remove("delay-500");
            document.querySelector("main").classList.remove("duration-500");
            document.querySelector("main").classList.add("duration-200");
            document.querySelector("main").classList.remove("opacity-0");
        }
        else {
            document.querySelector("main").classList.remove("opacity-0");
        }
        window.addEventListener("scroll", (e) => this.onWindowScroll(e));
        window.addEventListener("resize", () => this.onResize());
    }
    isBlockEditorContext() {
        var _a, _b;
        const body = document.body;
        if (!body) {
            return false;
        }
        // Parent editor document and iframe content use different classes.
        if (body.classList.contains("block-editor-page") ||
            body.classList.contains("block-editor-iframe__body") ||
            body.classList.contains("editor-styles-wrapper")) {
            return true;
        }
        // In iframe contexts, fall back to parent editor class when accessible.
        if (window.self !== window.top) {
            try {
                return !!((_b = (_a = window.parent.document) === null || _a === void 0 ? void 0 : _a.body) === null || _b === void 0 ? void 0 : _b.classList.contains("block-editor-page"));
            }
            catch (_error) {
                return false;
            }
        }
        return false;
    }
    onResize() {
        document.documentElement.style.setProperty("--app-height", window.innerHeight + "px");
    }
    iOS() {
        return (["iPad Simulator", "iPhone Simulator", "iPod Simulator", "iPad", "iPhone", "iPod"].includes(navigator.platform) ||
            // iPad on iOS 13 detection
            (navigator.userAgent.includes("Mac") && "ontouchend" in document));
    }
    onWindowScroll(e) {
        const newY = window.scrollY;
        if (!this.privacyButton) {
            this.privacyButton = document.querySelector("#CookiebotWidget");
        }
        if (!this.privacyButton || this.privacyButton.classList.contains("CookiebotWidget-open")) {
            return;
        }
        if (newY > this.lastScrollPosition && newY > this.SCROLL_AMOUNT_MIN) {
            this.privacyButton.style.transform = "translateX(-300%)";
        }
        else {
            this.privacyButton.style.transform = "translateX(0%)";
        }
        this.lastScrollPosition = newY;
    }
    deleteCookie(name) {
        const cookies = document.cookie.split('; ');
        if (cookies.find(row => row.startsWith(name))) {
            // delete the cookie if it exists
            document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; SameSite=Strict`;
        }
    }
}
